import { ConfirmationService } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/user/auth.service';
import { DashboardService } from '../../services/dashboard/dashboard-service.service';
import { Observable } from 'rxjs/Observable';
import { Indicator } from '../../models/dashboard.model';
import { environment } from '../../../environments/environment';
import { ApiMethods, Permission, PermissionConfiguration } from '../../models/permission.model';
import { PermsService } from '../../services/utils/perms.service';
import { IndicatorsService } from '../../services/indicators/indicators.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './dashboard.html'

})
export class DashboardComponent implements OnInit {

  public cards: boolean[];
  public indicators: Array<Indicator>;
  public referencePeriod: any;

  version: string = environment.VERSION;
  indicatorPermissionCheck: PermissionConfiguration = {
    ms_base: 'koncentro-common',
    operation: 'dashboardIndicators',
    method: ApiMethods.GET
  };

  ua = window.navigator.userAgent;

  constructor(
    private router: Router,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private translate: TranslateService,
    private srvPerms: PermsService,
    private indicatorService: IndicatorsService,
    private confirmationService: ConfirmationService) {
  }

  ngOnInit() {

    /* eliminato check/popup versione UI , gestito aggiungendo --env=prod --aot --output-hashing=all  nello script di build
    this.translate.get([
      'UI.VERSION',
      'dashboard.alertIEHeader',
      'dashboard.alertIEMsg'
    ]).subscribe(res => {
      // Alert in caso di Internet Explorer
      if (this.ua.includes('MSIE ') || this.ua.includes('Trident/') || this.ua.includes('Edge/')) {
        this.confirmationService.confirm({
          header: res['dashboard.alertIEHeader'],
          message: res['dashboard.alertIEMsg'],
          accept: () => false,
          acceptLabel: 'Ok',
          rejectVisible: false
        });
      }
      // Controllo ultima versione rilasciata della UI e la confronto con quella installata
      if (this.version !== res['UI.VERSION'] && (new Date(this.authService.user.tokenExpireDate) > new Date)) {
        this.translate.get(
          'dashboard.alertRefreshCache',
          {uiVersion: this.version, dbVersion: res['UI.VERSION']}
        ).subscribe(alertMsg => {
          this.confirmationService.confirm({
            message: alertMsg,
            acceptLabel: 'Ok',
            rejectVisible: false
          });
        });
      } 
    });
    */

    this.translate.onLangChange.subscribe(() => {
      this.initPage()
    });

    this.initPage();

  }

  initPage() {
    this.srvPerms.get(this.indicatorPermissionCheck.ms_base) // FIXME questo servizio è scritto MALE. non è così che dovrebbe essere un servizio asincrono.
      .subscribe(() => {
        this.indicators = [];

        const user = this.authService.user;
        this.cards = [
          user.role === 'S' || user.role === 'A',
          user.enabledApplications.indexOf(11) !== -1,
          user.enabledApplications.indexOf(3) !== -1
        ];

        const requests = [];

        let arrayCallIndicator: Map<string, {  icon: string, title: string, order: number }>;
        let indicatorApiEndpoints: Array<string>;

        indicatorApiEndpoints = [
          'YearVisitMeasures'
        ];

        const pMap: Permission[] = this.srvPerms.permissions[this.indicatorPermissionCheck.ms_base];

        if (pMap !== null && pMap !== undefined) {
          const p = pMap.find(op => op.operationName === this.indicatorPermissionCheck.operation);
          if (p && p.allowsGET) {

            this.indicatorService.getReferenceDates('Dashboard').subscribe((response) => {
              // date format returned by BE should be a string like '1968-11-16T00:00:00'.
              console.log('DATE DI RIFERIMENTO WS RESPONSE:', response);
              this.referencePeriod = response[0];
            });

            arrayCallIndicator = new Map([
              ['total_revenue_ytd', { icon: 'fa fa-file', title: 'total_revenue_ytd', order: 0}],
              ['total_visits_ytd', { icon: 'fa fa-shopping-cart', title: 'total_visits_ytd', order: 1}],
              ['avg_spent_per_visit', { icon: 'fa fa-calculator', title: 'avg_spent_per_visit', order: 2}],
            ]);

            indicatorApiEndpoints.forEach((name) => {
              requests.push(this.dashboardService.getIndicator(name));
            });

            Observable.zip(...requests).subscribe((res) => {

              res.forEach((indicatorList: Array<Indicator>) => {

                for (const indicatorSingle of indicatorList) {
                  if (arrayCallIndicator.has(indicatorSingle['name'])) {
                    this.indicators.push({
                      key: indicatorSingle['key'],
                      name: indicatorSingle['name'],
                      current: indicatorSingle['current'],
                      previous: indicatorSingle['previous'],
                      description: indicatorSingle['description'],
                      unitOfMeasure: indicatorSingle['unitOfMeasure'],
                      diffPercentage: indicatorSingle['diffPercentage'],
                      icon: arrayCallIndicator.get(indicatorSingle['name']).icon,
                      order: arrayCallIndicator.get(indicatorSingle['name']).order,
                      title: arrayCallIndicator.get(indicatorSingle['name']).title,
                    });
                  }
                }
              });
              this.indicators.sort((a, b) => a.order - b.order);
            });
          }
        }
      });
  }

  getDisplayNameForWelcome(): string {
    const user = this.authService.user;
    if (typeof user.lastName != 'undefined')
      return user.firstName + ' ' + user.lastName;
    return user.firstName;
  }

  getCompanyId(): string {
    return this.authService.user.selectedCompany.toString();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/dashboard/dashboard.component.ts